import {useState,useEffect} from "react";
import "../../style/scss/App.scss";
import { Form, FormDate, FormActions, FormInput, FormSelect } from "../Controls/Form";
import BreadCrumb from "../Controls/BreadCrumb";
import PackageListItem from "../ListItems/PackageListItem";
import { Link } from "react-router-dom";
import UserData from "../Controls/UserData";
import { MdAddBox } from "react-icons/md";
import { toast } from "react-toastify";

export default function PackageItemEdit(props) {
   const [lookups] = useState(UserData.Lookups());
   const [pkg, updatePackage] = useState(props.location.state || {});
   const [breadcrumb, updateBreadcrumb] = useState(props.location.state.breadcrumb || {});
   useEffect(
      (e) => {
         if (breadcrumb) {
            var b = breadcrumb;
            if (b.length) {
               if (!b[b.length - 1].label.startsWith("Edit Package")) {
                  b.push({ label: "Edit Package", route: window.location.pathname });
                  updateBreadcrumb(b);
               }
            }
         }
      },
      [breadcrumb]
   );
   async function onDoneAsync(e) {
      debugger;
      toast.success("");
   };
   const Return = (e) => {
      debugger;
   };
   const onDelete = (e) => {
      debugger;
   };
   let packageItemTypes = lookups.packageItemTypes.map((bt) => {
      return { ID: bt.Key, Name: bt.Value };
   });
   return (
      <div className="pagebody">
         <BreadCrumb props={breadcrumb} />
         <div className="tabbody">
            <h1>Package Item Edit</h1>
            <Form object={pkg} onUpdate={updatePackage}>
               <FormSelect
                  label="Package Item Types"
                  field="packageTypeID"
                  valueProp="ID"
                  labelProp="Name"
                  options={packageItemTypes}
               />
               <FormInput field="name" />
               <FormDate label="In" field="effectiveDate" />
               <FormDate label="Expiration Date" field="killDate" />
               <FormInput label="Health Care Provider" field="healthCareProviderName" />
               <FormActions
                  onSaveAsync={async (e) => { await onDoneAsync(e); }}
                  onCancelAsync={async (e) => { await Return(e); }}
                  onDeleteAsync={async (e) => { await onDelete(e); }}
               />
               <ul>
                  {pkg && pkg.Packages ? (
                     pkg.Packages.map((b) => {
                        return (
                           <li key={b.id}>
                              <PackageListItem package={b} />
                           </li>
                        );
                     })
                  ) : (
                     <span></span>
                  )}
               </ul>

               <div className="section">
                  <div className="listTitle">
                     <span>Employer Package Items</span>
                     <div className="listTitleIcons">
                        <Link
                           to={{
                              pathname: "/PackageItemEdit",
                              state: {
                                 employerName: "",
                                 packageName: "",
                                 packageID: 0,
                              },
                           }}
                        >
                           <MdAddBox />
                        </Link>
                     </div>
                  </div>
                  <div className="sectionData">
                     <ul>
                        {pkg && pkg.Packages ? (
                           pkg.Packages.map((b) => {
                              return (
                                 <li key={b.id}>
                                    <PackageListItem packages={b} />
                                 </li>
                              );
                           })
                        ) : (
                           <span></span>
                        )}
                     </ul>
                  </div>
               </div>
            </Form>

         </div>
      </div>
   );
}


